var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.base.wrapper]},[_c('BaseIcon',{class:_vm.base.icon,attrs:{"name":'info',"alt":'( i )',"size":'14px'}}),_c('span',{class:[
      _vm.base.text,
      _vm.type[_vm.typeScaleClass('eta')],
      _vm.space.paddingHorizontalXnarrow,
      _vm.space.paddingVerticalXxnarrow
    ]},[_vm._v("\n    "+_vm._s(_vm.body)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }